import { FC } from "react";

const IVerifyOrgs: FC = () => (
    <svg
        width="228"
        height="228"
        viewBox="0 0 228 228"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_dd)">
            <rect
                x="24"
                y="8"
                width="180"
                height="180"
                rx="39"
                fill="url(#paint0_linear)"
            />
        </g>
        <rect
            x="24"
            y="8"
            width="180"
            height="180"
            rx="39"
            fill="url(#paint1_linear)"
        />
        <mask
            id="mask0"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="24"
            y="8"
            width="180"
            height="180"
        >
            <rect x="24" y="8" width="180" height="180" fill="white" />
        </mask>
        <g mask="url(#mask0)" />
        <path
            d="M76.7148 109.135H60.5C60.2239 109.135 60 109.359 60 109.635V149.324C60 149.6 60.2239 149.824 60.5 149.824H76.7148C76.991 149.824 77.2148 149.6 77.2148 149.324V109.635C77.2148 109.359 76.991 109.135 76.7148 109.135Z"
            fill="#B02145"
        />
        <path
            d="M109.334 149.823C109.124 149.823 108.936 149.692 108.864 149.494L88.618 93.8129C88.5462 93.6153 88.3584 93.4838 88.1481 93.4838H60.5C60.2239 93.4838 60 93.2599 60 92.9838V76.769C60 76.4928 60.2239 76.269 60.5 76.269H100.345C100.555 76.269 100.743 76.4005 100.814 76.5981L117.174 121.587C117.333 122.026 117.954 122.026 118.113 121.587L146.424 43.7334C146.496 43.5358 146.684 43.4043 146.894 43.4043H164.286C164.633 43.4043 164.875 43.7491 164.756 44.0752L126.423 149.494C126.351 149.692 126.163 149.823 125.953 149.823H109.334Z"
            fill="#0E212F"
        />
        <path
            d="M66.675 62.25C64.4083 62.25 62.6417 61.675 61.375 60.525C60.1083 59.375 59.4417 57.6667 59.375 55.4C59.3583 54.9167 59.35 54.2083 59.35 53.275C59.35 52.325 59.3583 51.6083 59.375 51.125C59.4417 48.9083 60.125 47.2083 61.425 46.025C62.725 44.8417 64.475 44.25 66.675 44.25C68.875 44.25 70.625 44.8417 71.925 46.025C73.2417 47.2083 73.9333 48.9083 74 51.125C74.0333 52.0917 74.05 52.8083 74.05 53.275C74.05 53.725 74.0333 54.4333 74 55.4C73.9167 57.6667 73.2417 59.375 71.975 60.525C70.7083 61.675 68.9417 62.25 66.675 62.25ZM66.675 59.375C67.7917 59.375 68.6833 59.0417 69.35 58.375C70.0167 57.6917 70.375 56.6583 70.425 55.275C70.4583 54.275 70.475 53.6 70.475 53.25C70.475 52.8667 70.4583 52.1917 70.425 51.225C70.375 49.8417 70.0167 48.8167 69.35 48.15C68.6833 47.4667 67.7917 47.125 66.675 47.125C65.575 47.125 64.6917 47.4667 64.025 48.15C63.3583 48.8167 63 49.8417 62.95 51.225C62.9333 51.7083 62.925 52.3833 62.925 53.25C62.925 54.1 62.9333 54.775 62.95 55.275C63 56.6583 63.35 57.6917 64 58.375C64.6667 59.0417 65.5583 59.375 66.675 59.375ZM77.9328 62C77.7661 62 77.6245 61.9417 77.5078 61.825C77.3911 61.7083 77.3328 61.5667 77.3328 61.4V45.125C77.3328 44.9417 77.3828 44.7917 77.4828 44.675C77.5995 44.5583 77.7495 44.5 77.9328 44.5H84.4078C86.4411 44.5 88.0328 44.975 89.1828 45.925C90.3495 46.875 90.9328 48.225 90.9328 49.975C90.9328 51.1917 90.6328 52.2167 90.0328 53.05C89.4495 53.8667 88.6328 54.4583 87.5828 54.825L91.2328 61.2C91.2828 61.3 91.3078 61.3917 91.3078 61.475C91.3078 61.625 91.2495 61.75 91.1328 61.85C91.0328 61.95 90.9161 62 90.7828 62H88.5078C88.2411 62 88.0328 61.9417 87.8828 61.825C87.7495 61.7083 87.6245 61.5417 87.5078 61.325L84.2828 55.4H80.8078V61.4C80.8078 61.5667 80.7495 61.7083 80.6328 61.825C80.5328 61.9417 80.3911 62 80.2078 62H77.9328ZM84.3328 52.575C85.3328 52.575 86.0828 52.35 86.5828 51.9C87.0995 51.45 87.3578 50.8 87.3578 49.95C87.3578 49.1 87.0995 48.4417 86.5828 47.975C86.0828 47.5083 85.3328 47.275 84.3328 47.275H80.8078V52.575H84.3328ZM100.905 62.25C98.6219 62.25 96.8386 61.6583 95.5553 60.475C94.2886 59.2917 93.6136 57.6417 93.5303 55.525C93.5136 55.0417 93.5053 54.2667 93.5053 53.2C93.5053 52.1333 93.5136 51.3583 93.5303 50.875C93.6136 48.8083 94.2969 47.1917 95.5803 46.025C96.8803 44.8417 98.6553 44.25 100.905 44.25C102.439 44.25 103.755 44.5083 104.855 45.025C105.955 45.5417 106.789 46.1917 107.355 46.975C107.922 47.7417 108.222 48.5 108.255 49.25V49.3C108.255 49.4333 108.205 49.55 108.105 49.65C108.005 49.7333 107.88 49.775 107.73 49.775H105.155C104.989 49.775 104.864 49.75 104.78 49.7C104.697 49.6333 104.622 49.525 104.555 49.375C104.322 48.7583 103.914 48.2333 103.33 47.8C102.747 47.35 101.939 47.125 100.905 47.125C99.7386 47.125 98.8219 47.4417 98.1553 48.075C97.5053 48.7083 97.1553 49.6833 97.1053 51C97.0886 51.4833 97.0803 52.2167 97.0803 53.2C97.0803 54.1667 97.0886 54.9 97.1053 55.4C97.2053 58.05 98.4886 59.375 100.955 59.375C102.139 59.375 103.089 59.0583 103.805 58.425C104.522 57.775 104.88 56.8167 104.88 55.55V54.775H101.83C101.647 54.775 101.497 54.7167 101.38 54.6C101.28 54.4833 101.23 54.3333 101.23 54.15V52.825C101.23 52.6417 101.28 52.4917 101.38 52.375C101.497 52.2583 101.647 52.2 101.83 52.2H107.805C107.989 52.2 108.13 52.2583 108.23 52.375C108.347 52.4917 108.405 52.6417 108.405 52.825V55.45C108.405 56.8333 108.097 58.0417 107.48 59.075C106.88 60.0917 106.014 60.875 104.88 61.425C103.747 61.975 102.422 62.25 100.905 62.25ZM117.685 62.25C116.202 62.25 114.927 62.025 113.86 61.575C112.793 61.125 111.985 60.5333 111.435 59.8C110.885 59.0667 110.593 58.275 110.56 57.425C110.56 57.275 110.61 57.15 110.71 57.05C110.81 56.95 110.935 56.9 111.085 56.9H113.31C113.51 56.9 113.66 56.9417 113.76 57.025C113.877 57.0917 113.985 57.2083 114.085 57.375C114.252 57.9417 114.635 58.4167 115.235 58.8C115.835 59.1833 116.652 59.375 117.685 59.375C118.868 59.375 119.76 59.1833 120.36 58.8C120.96 58.4 121.26 57.85 121.26 57.15C121.26 56.6833 121.102 56.3 120.785 56C120.485 55.7 120.027 55.4417 119.41 55.225C118.81 55.0083 117.91 54.7417 116.71 54.425C114.743 53.9583 113.302 53.3417 112.385 52.575C111.485 51.7917 111.035 50.6833 111.035 49.25C111.035 48.2833 111.293 47.425 111.81 46.675C112.343 45.925 113.102 45.3333 114.085 44.9C115.085 44.4667 116.243 44.25 117.56 44.25C118.927 44.25 120.11 44.4917 121.11 44.975C122.11 45.4583 122.868 46.0667 123.385 46.8C123.918 47.5167 124.202 48.2333 124.235 48.95C124.235 49.1 124.185 49.225 124.085 49.325C123.985 49.425 123.86 49.475 123.71 49.475H121.385C121.035 49.475 120.793 49.3167 120.66 49C120.56 48.4667 120.227 48.025 119.66 47.675C119.093 47.3083 118.393 47.125 117.56 47.125C116.627 47.125 115.893 47.3 115.36 47.65C114.827 48 114.56 48.5083 114.56 49.175C114.56 49.6417 114.693 50.025 114.96 50.325C115.227 50.625 115.643 50.8917 116.21 51.125C116.793 51.3583 117.627 51.6167 118.71 51.9C120.177 52.2333 121.343 52.6083 122.21 53.025C123.093 53.4417 123.743 53.9667 124.16 54.6C124.577 55.2333 124.785 56.0417 124.785 57.025C124.785 58.0917 124.485 59.025 123.885 59.825C123.302 60.6083 122.468 61.2083 121.385 61.625C120.318 62.0417 119.085 62.25 117.685 62.25Z"
            fill="#0E212F"
        />
        <defs>
            <filter
                id="filter0_dd"
                x="0"
                y="0"
                width="228"
                height="228"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="16" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.008 0 0 0 0 0.022069 0 0 0 0 0.032 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.008 0 0 0 0 0.022069 0 0 0 0 0.032 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear"
                x1="114"
                y1="8"
                x2="114"
                y2="188"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.140625" stopColor="#F6F7F9" />
                <stop offset="0.880208" stopColor="#ECEFF3" />
            </linearGradient>
            <linearGradient
                id="paint1_linear"
                x1="114"
                y1="8"
                x2="114"
                y2="188"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.140625" stopColor="#F6F7F9" />
                <stop offset="0.880208" stopColor="#ECEFF3" />
            </linearGradient>
        </defs>
    </svg>
);

export default IVerifyOrgs;
